<template>
    <div class="wrapper">
        <h2>Data Retention</h2>

        <div id="storage-period">
            <custom-input type="text" name="storage period" v-model="newStoragePeriod" ref="newStoragePeriod" label="Storage period in days" placeholder="storage period" :validationRules="{required: true, numeric: true}"/>
        </div>
        <div>
            Last cleaned: {{ lastChecked }}
        </div>

        <button class="primary" type="button" v-on:click="validation">Save</button>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import CustomInput from '../additional/customInput';

export default {
    name: 'settingsDataRetention',
    components: {CustomInput},
    mixins: [
        Default
    ],
    inject: {
        $validator: '$validator' // Get the parent $validator instance
    },
    data() {
        return {
            newStoragePeriod: '',
            lastChecked: ''
        };
    },
    mounted() {
        this.getStoragePeriod();
    },
    methods: {
        validation: function() {
            this.$parleyAdmin.validateMultiple([this.$refs['newStoragePeriod']], function(value) {
                if (value)
                    return this.saveNewStoragePeriod();
            }.bind(this));
        },
        saveNewStoragePeriod: function() {
            return new Promise((resolve) => {
                return this.$http.put('v1.1/config', {
                    storagePeriod: this.newStoragePeriod * (24 * (60 * 60)) // Convert days to seconds
                }).then(response => {
                    // Success callback
                    this.$parleyAdmin.queryErrors.addError('Successfully saved changes', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
                    resolve(true);
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while trying to save the changes');
                    resolve(false);
                });
            });
        },
        getStoragePeriod: function() {
            return new Promise((resolve) => {
                return this.$http.get('v1.1/config', {}).then(response => {
                    // Success callback
                    this.newStoragePeriod = response.data.data.storagePeriod / ((60 * 60) * 24);
                    if (response.data.data.storagePeriodLastChecked > 0)
                        this.lastChecked = new Date(parseInt(response.data.data.storagePeriodLastChecked)).toUTCString();
                    else
                        this.lastChecked = 'never';

                    resolve(true);
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while retrieving the storage period, please try again later');
                    resolve(false);
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper {
    /*width: 12em;*/
    #storage-period {
        width: 12em;
    }
}
</style>
